import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css/animate.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Contact.css'; // You can move your custom CSS there
import Seo from "../components/Seo";



const Contact = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false
    });

    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const hero = document.querySelector('.contact-hero');
      if (hero) {
        hero.style.backgroundPositionY = `${scrolled * 0.5}px`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Seo
        title="Contact Mortbuzz - Get in Touch for Loans & Financial Services"
        description="Have questions or need loan assistance? Contact Mortbuzz today for expert advice on home loans, business loans, car loans, and more."
        keywords="Contact Mortbuzz, loan assistance, home loan help, business loan support, car loan queries, financial advice"
        canonical="https://www.mortbuzz.in/contact"
      />


    

      <section className="contact-hero d-flex align-items-center text-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center" data-aos="zoom-in">
              <h1 className="display-2 fw-bold mb-4 animate__animated animate__fadeInDown">
                <span className="floating-element">📞</span><br />
                Connect With Your Personal<br />
                <span className="text-warning">Home Loan Expert</span>
              </h1>
              <div className="d-flex justify-content-center gap-3 mt-5">
                <a href="tel:18002104422" className="btn btn-light btn-lg pulse px-5 py-3 rounded-pill">
                  <i className="bi bi-telephone"></i> 1800 210 4422
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container py-5 my-5">
        <div className="row g-5 justify-content-center">

          <div className="col-md-6" data-aos="fade-right">
            <div className="contact-card p-5 h-100 holographic-effect border border-primary">
              <h2 className="display-5 fw-bold text-primary mb-4">
                <i className="bi bi-geo-alt"></i> Visit Us
              </h2>
              <p className="lead mb-4">
                Mortbuzz Solutions India Pvt Ltd<br />
                2nd Floor, Mahadik House<br />
                Bhosale Nagar, Hadapsar<br />
                Pune - 411028
              </p>
              <div className="map-container rounded-3 overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15134.455012393357!2d73.92422475000001!3d18.501146799999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c10c06c58afd%3A0xde33a8db57e6910c!2sMortBuzz%20-%20Home%20Loan%20%7C%20Loan%20Against%20Property!5e0!3m2!1sen!2sin!4v1748247553417!5m2!1sen!2sin"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="fade-left">
            <div className="contact-card p-5 h-100 border border-primary">
              <h2 className="display-5 fw-bold text-primary mb-4">
                <i className="bi bi-envelope-paper"></i> Digital Connect
              </h2>
              <div className="d-flex align-items-center gap-3 mb-4">
                <i className="bi bi-globe fs-1 text-primary"></i>
                <a href="https://www.mortbuzz.in" className="h4 text-dark">www.mortbuzz.in</a>
              </div>
              <div className="d-flex align-items-center gap-3 mb-4">
                <i className="bi bi-envelope fs-1 text-primary"></i>
                <div>
                  <a href="mailto:contact@mortbuzz.in" className="h5 d-block">contact@mortbuzz.in</a>
                  <a href="mailto:support@mortbuzz.in" className="h5 d-block">support@mortbuzz.in</a>
                </div>
              </div>
              <div className="border-top pt-5">
                <h3 className="h2 fw-bold text-primary mb-4">
                  <i className="bi bi-calendar2-heart"></i> Book Appointment
                </h3>
                <p className="lead mb-4">
                  Schedule a free consultation with our relationship manager<br />
                  at your home or office
                </p>
                <button className="btn btn-primary btn-lg px-5 py-3 rounded-pill border border-primary pulse">
                  Call Now <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="social-media-container text-center py-5" data-aos="fade-up">
        <h3 className="mb-4 text-primary">Connect With Us</h3>
        <div className="d-flex justify-content-center gap-4">
          <a href="#" className="social-icon facebook animate__animated animate__pulse animate__infinite animate__slower">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="#" className="social-icon twitter animate__animated animate__pulse animate__infinite animate__slower">
            <i className="bi bi-twitter"></i>
          </a>
          <a href="#" className="social-icon linkedin animate__animated animate__pulse animate__infinite animate__slower">
            <i className="bi bi-linkedin"></i>
          </a>
          <a href="#" className="social-icon instagram animate__animated animate__pulse animate__infinite animate__slower">
            <i className="bi bi-instagram"></i>
          </a>
          <a href="#" className="social-icon youtube animate__animated animate__pulse animate__infinite animate__slower">
            <i className="bi bi-youtube"></i>
          </a>
        </div>
      </div>
    </>
  );
};

export default Contact;
